import { useContext } from 'react';
import { TitleContext } from '../context/titleContext';
var useTitle = function () {
    var value = useContext(TitleContext);
    return value;
};
export default useTitle;
